
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-wins/choose-treats",
      function () {
        return require("private-next-pages/my-wins/choose-treats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-wins/choose-treats"])
      });
    }
  